/**
 *  @brief Allows you to mount all view components, plugins, scripts, in the index.html file.
 *  @bug No known bugs.
 */

import Vue from 'vue'

// Main view
import App from './App.vue'

// Plugins
import router from './router'
import store from './store'
import { vuetify, scenarioData } from './plugins'

// Styles
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@mdi/font/css/materialdesignicons.css'

// Vue config
Vue.config.productionTip = false

// Sapio config
new SAPIO.Loader(process.env.VUE_APP_SERVER_URL)

// Mounted main view
new Vue({
  data: scenarioData,
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app')
